var exports = {
  "n": "xf0b3b88a--b92e9d--link",
};

module.exports = exports;
